module.exports = __webpack_public_path__ + "images/marketing/sales_productivity-metrics1.png";